/* Copyright */
export function getStage(): string {
  const stage = process.env.REACT_APP_CLIENT_STAGE;
  if (!stage) {
    throw new Error("Stage not set");
  }
  return stage;
}
